import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { cleanBlogSlug } from "../seo/blogSlug";

/** Old doubled path: /blogs/blog/<slug> */
export default function LegacyBlogRedirect() {
  const { legacySlug } = useParams();
  const clean = cleanBlogSlug(legacySlug, "");
  if (!clean) return <Navigate to="/blogs" replace />;
  return <Navigate to={`/blogs/${clean}`} replace />;
}
